module.exports = __webpack_public_path__ + "img/9788958285434.b48f4996.jpg";